import * as _ from 'lodash';
import { combineReducers, Reducer } from 'redux';
import { ICategories, ICategoryResult } from '../state-helpers/categories';
import {
    IAction,
    ActionType,
    IUpdateSearchCategory,
    ISetMobileCategoriesVisibility,
    ISetSelectedCategoryCount,
    setMobileCategoriesVisibility,
    setSelectedCategoryCount
} from '../actions/index';

export const categoriesModel: Reducer<ICategories> = combineReducers({
    categories: updateCategoriesModel,
    mobileCategoriesVisible: mobileCategoriesVisibilityModel,
    selectedCategoryCount: updatedSelectedCategoryCount
});


export function updateCategoriesModel(state: ICategoryResult[], action: IUpdateSearchCategory) {
    if (typeof state === 'undefined') {
        state = [] as ICategoryResult[];
    }

    switch (action.type) {
        case ActionType.UPDATE_CATEGORIES:
            return action.categories;
        default:
            return state;
    }
}

export function mobileCategoriesVisibilityModel(state: boolean, action: ISetMobileCategoriesVisibility) {
    if (typeof state === 'undefined') {
        state = false;
        return state;
    }

    switch (action.type) {
        case ActionType.SET_MOBILE_CATEGORIES_VISIBILITY:
            return setMobileCategoriesVisibility(action.visible).visible;
        default:
            return state;
    }
}

export function updatedSelectedCategoryCount(state: number, action: ISetSelectedCategoryCount) {

    if (typeof state === 'undefined') {
        state = 0;
    }

    switch (action.type) {
        case ActionType.SET_SELECTED_CATEGORY_COUNT:
            return setSelectedCategoryCount(action.selectedCategoryCount).selectedCategoryCount;
        default:
            return state;
    }
}
